import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Logo from '../../../assets/img/logo-wowflow.svg';
import {
  WowDisplayFlex,
  WowIcon,
} from '../../../components_new/WowBasicElements';
import { buttonDisabled } from '../../../config/colors';

import {
  Wrapper,
  InnerWrapper,
  LogoWrapper,
  Content,
  Title,
  Text,
} from './styles';
import CtaButton from '../../external/auth/components/CtaButton';
import { selectPrivacyConsent } from '../../../redux/config/selectors';
import usePrivacyConsent from './usePrivacyConsent';
import PrivacyAgree from '../../../components_new/PrivacyAgree';
import { FormProvider, useForm } from 'react-hook-form';
import { vestResolver } from '@hookform/resolvers/vest';
import { formValidation } from './utils';
import { getUser } from '../../../redux/user/selectors';

const Privacy = () => {
  const privacyConsent = useSelector(selectPrivacyConsent);
  const loggedInUser = useSelector(getUser);

  const formMethods = useForm({
    defaultValues: {
      consent_signed: false,
    },
    resolver: vestResolver(formValidation),
    mode: 'onSubmit',
    shouldFocusError: false,
  });

  const { formState } = formMethods;
  const { isDirty, isValid } = formState;
  const canSubmit = isDirty && isValid;

  const { handleSubmitPrivacyConsent, isLoadingSignConsent } =
    usePrivacyConsent();

  const titleKey = privacyConsent?.outdated
    ? 'updated_privacy_policy'
    : 'we_value_privacy';
  const textKey = privacyConsent?.outdated
    ? 'privacy_policy_accept_to_continue'
    : 'info_privacy_policy';

  return (
    <Wrapper>
      <InnerWrapper width={600}>
        <LogoWrapper>
          <img src={Logo} alt="wowflow" />
        </LogoWrapper>
        <FormProvider {...formMethods}>
          <Content onSubmit={handleSubmitPrivacyConsent}>
            <WowDisplayFlex justify="center" direction="column">
              <WowIcon
                className="icon icon-lock"
                size={80}
                spaceRight={0}
                color={buttonDisabled}
              />
              <Title maxWidth={loggedInUser?.language === 'de' ? 450 : null}>
                <FormattedMessage id={titleKey} />
              </Title>
              <Text>
                <FormattedMessage id={textKey} />
              </Text>
              <PrivacyAgree url={privacyConsent?.url} />
              {/*TMP - move */}
              <CtaButton
                textKey="button_accept_continue"
                disabled={!canSubmit}
                isLoading={isLoadingSignConsent}
              />
            </WowDisplayFlex>
          </Content>
        </FormProvider>
      </InnerWrapper>
    </Wrapper>
  );
};

export default Privacy;
